import React from 'react';

/**
 * 카드 이벤트 컴포넌트
 */
function CardEvent({ cardDiscount }) {
  const cardEventTitle = cardDiscount.data[0].title;

  return <p>{cardEventTitle || null}</p>;
}

export default CardEvent;
